export const ExperienceCategoryList = [
  "experiment",
  "personalization",
] as const;

export type ExperienceCategory = (typeof ExperienceCategoryList)[number];
